import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";


// GET ALL CITIES

export const GetAllPincode = createAsyncThunk(
  "masters/pincode/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.pincode}?pincode=${filter?.pincode || ""}` +
          `&country_id=${filter?.country_id || ""}` +
          `&state_id=${filter?.state_id || ""}` +
          `&city_id=${filter?.city_id || ""}` +
          `&page=${filter?.page || IDS.PAGE}` +
          `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// GET ONE CITY
export const GetPincode = createAsyncThunk(
  "masters/city/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.pincode}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// CREATE CITY

export const AddPincode = createAsyncThunk(
  "masters/city/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.pincode, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// UPDATE pincode

export const UpdatePincode = createAsyncThunk(
  "masters/pincode/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.pincode}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// DELETE CITY

export const DeletePincode = createAsyncThunk(
  "masters/pincode/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.pincode}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// CHANGE STATUS

export const StatusPincode = createAsyncThunk(
  "masters/pincode/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.pincode}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// SLICE
export const PincodeSlice = createSlice({
  name: "pincode",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET ALL ------------------------------------
      .addCase(GetAllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // GET ONE ------------------------------------
      .addCase(GetPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetPincode.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // ADD ----------------------------------------
      .addCase(AddPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // UPDATE -------------------------------------
      .addCase(UpdatePincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdatePincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (item) => item.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdatePincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // DELETE -------------------------------------
      .addCase(DeletePincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeletePincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (item) => item.id !== action.payload
        );
      })
      .addCase(DeletePincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // STATUS -------------------------------------
      .addCase(StatusPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (item) => item.id === action.payload?.id
        );
        if (index !== -1) {
          state.data[index].status = !state.data[index].status;
        }
      })
      .addCase(StatusPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default PincodeSlice.reducer;
